import { render, staticRenderFns } from "./VariantAttributePresetSelection.vue?vue&type=template&id=77bf732f&scoped=true&"
import script from "./VariantAttributePresetSelection.vue?vue&type=script&lang=js&"
export * from "./VariantAttributePresetSelection.vue?vue&type=script&lang=js&"
import style0 from "./VariantAttributePresetSelection.vue?vue&type=style&index=0&id=77bf732f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf732f",
  null
  
)

export default component.exports